<template>
  <div>
    <breadcrumbs :crumbs="['View As']"/>
    <!-- END PAGE HEADER-->
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="portlet light">
              <div class="portlet-title">
                <div class="caption caption-md">
                  <i class="icon-globe theme-font hide"></i>
                  <span class="caption-subject bold uppercase">Choose default organization</span>
                </div>
              </div>
              <div class="portlet-body">
                <form role="form" class="form-horizontal">
                  <div class="form-body">
                    <div class="form-group form-md-line-input has-warning">
                      <div class="col-md-12">
                        <div class="input-group">
                          <div class="input-group-control input-icon">
                            <i class="fa fa-search"></i>
                            <input type="text" placeholder="Type to search..." v-model="query" class="form-control">
                            <div class="form-control-focus"></div>
                          </div>
                          <span class="input-group-btn btn-right">
                            <button type="submit" data-style="expand-left"
                                    class="btn green mt-ladda-btn ladda-button search-btn-submit-pd" @click.prevent="">
                              <span class="ladda-label">Search</span>
                            </button>
                          </span>
                        </div>
                      </div>
                    </div>
                    <Spinner v-if="loading"/>
                    <vue-good-table
                      v-else-if="list.length"
                      :columns="columns"
                      :rows="search"
                      :pagination-options="{enabled: true}"
                      :sort-options="{
                        enabled: true,
                        initialSortBy: {field: 'organizationName', type: 'asc'}
                      }"
                    >
                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field === 'activationDate'">
                          {{ props.row.activationDate.date | formatDateModal }}
                        </span>

                        <button v-else-if="props.column.field === 'action'" class="btn green btn-sm" @click.prevent="setDefaultAccount(props.row.id)"
                                :disabled="props.row.default">{{ (props.row.default) ? 'Default' : 'Set as Default' }}
                        </button>
                        <span v-else-if="props.column.field === 'accountType'">{{ getAccountType(props.row) }}</span>
                        <span v-else>{{ props.formattedRow[props.column.field] }}</span>
                      </template>
                    </vue-good-table>
                    <div class="not-found-results" v-else>
                      <h4>Sorry, no search results were found.</h4>
                    </div>
                  </div>
                </form>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
  import _ from 'lodash';
  import {mapActions, mapGetters} from 'vuex';
  import Breadcrumbs from '@/components/Breadcrumbs';
  import Spinner from '@/components/Spinner';

  export default {
    data() {
      return {
        query: '',
        columns: [
          {
            label: 'Organization Name',
            field: 'organizationName',
            filterOptions: {enabled: true}
          },
          {
            label: 'System ID',
            field: 'systemId',
            filterOptions: {enabled: true}
          },
          {
            label: 'Account Type',
            field: 'accountType',
            filterOptions: {enabled: true}
          },
          {
            label: 'Account Owner',
            field: 'accountOwner',
            filterOptions: {enabled: true}
          },
          {
            label: 'Activation Date',
            field: 'activationDate',
            filterOptions: {enabled: false}
          },
          {
            label: 'Action',
            field: 'action',
            filterOptions: {enabled: false},
            sortable: false
          },
        ]
      }
    },
    components: {
      Breadcrumbs,
      Spinner,
    },
    computed: {
      ...mapGetters({
        list: 'getViewAsUsers',
        loading: 'getViewAsUsersLoading'
      }),
      search() {
        let self = this;
        return _.filter(this.list, function (o) {
          return (o.organizationName.toLowerCase().search(self.query.toLowerCase()) !== -1) ||
            (o.systemId.toLowerCase().search(self.query.toLowerCase()) !== -1)
        });
      }
    },
    methods: {
      ...mapActions({
        getUsers: 'GET_USERS_LIST',
        setDefaultAccount: 'SET_DEFAULT_ACCOUNT_ACTION'
      }),
      getAccountType(account) {
        if (account.accountType === 'program') {
          return 'Program';
        } else {
          return account.parentAccount ? 'Child Account' : 'Parent Account';
        }
      }
    },
    mounted() {
      this.getUsers()
    },
  }
</script>



// WEBPACK FOOTER //
// ViewAs.vue?44bea99a